import React, { useState, useEffect } from "react";
import "./Inventory.css";
import Table from "../../containers/UI/Table/Table";
import ReactPaginate from "react-paginate";

import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import * as actions from "../../store/actions";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";

import Spinner from "../../containers/UI/Spinner/Spinner";

import queryString from "query-string";

import { FaClipboardList } from "react-icons/fa";
import { ErrorBoundary } from "../../containers/ErrorBoundary";

const Previous = () => {
  return (
    <div className="paginationIcons">
      <ArrowBackIcon fontSize="small" />
      <span>Previous</span>
    </div>
  );
};

const Next = () => {
  return (
    <div className="paginationIcons">
      <span>Next</span>
      <ArrowForwardIcon fontSize="small" />
    </div>
  );
};

const Inventory = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedItemID, setSelectedItemID] = useState(null);
  const [initialPage, setInitialPage] = useState(0);

  const getInventoryHandler = () => {
    const { limit, page, sortBy, sortOrder, searchInput, categoryId, getInventory } = props;
    getInventory(limit, page, sortBy, sortOrder, searchInput, categoryId);
  };

  useEffect(() => {
    const values = queryString.parse(location.search);
    const { limit, page, sortBy, sortOrder, searchInput, categoryId, getInventory, updatePageSelect, getCategories } = props;

    const initializeInventory = async () => {
      const pageFromUrl = values.page ? parseInt(values.page) : 1;
      setInitialPage(pageFromUrl - 1);
      await updatePageSelect(pageFromUrl);

      getCategories();
      getInventory(limit, page, sortBy, sortOrder, searchInput, categoryId);
    };

    initializeInventory();

    const handlePopState = async () => {
      const values = queryString.parse(location.search);
      const pageFromUrl = values.page ? parseInt(values.page) : 1;
      setInitialPage(pageFromUrl - 1);
      await updatePageSelect(pageFromUrl);
      getInventory(limit, page, sortBy, sortOrder, searchInput, categoryId);
    };

    window.onpopstate = handlePopState;

    return () => {
      window.onpopstate = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const handlePageClick = async (data) => {
    const newPage = data.selected + 1; // Convert 0-indexed to 1-indexed
    navigate(`/inventory?page=${newPage}`);
    await props.updatePageSelect(newPage);
    getInventoryHandler();
  };

  const handleChangePerPage = async (event) => {
    await props.updatePerPageSelect(event.target.name, event.target.value);
    getInventoryHandler();
  };

  const handleSortChange = async (event) => {
    const value = event.target.value;
    let sortBy = 'createdAt';
    let sortOrder = 'desc';

    switch (value) {
      case 'name-asc':
        sortBy = 'name';
        sortOrder = 'asc';
        break;
      case 'name-desc':
        sortBy = 'name';
        sortOrder = 'desc';
        break;
      case 'date-desc':
        sortBy = 'createdAt';
        sortOrder = 'desc';
        break;
      case 'date-asc':
        sortBy = 'createdAt';
        sortOrder = 'asc';
        break;
      default:
        break;
    }

    await props.updatePerPageSelect('sortBy', sortBy);
    await props.updatePerPageSelect('sortOrder', sortOrder);
    getInventoryHandler();
  };

  const handleItemClick = (productMerchantId) => {
    navigate(`/itemdetails/${productMerchantId}`);
  };

  const deleteHandler = (id) => {
    setSelectedItemID(id);
    setConfirmModal(true);
  };

  const closeDeleteModal = () => {
    getInventoryHandler();
  };

  const closeConfirmModal = () => {
    setConfirmModal(false);
  };

  const onContinueHandler = () => {
    props.DeleteItem(selectedItemID, props.profile.id);
    setConfirmModal(false);
  };

  const {
    loading,
    pageCount,
    numberOfItems,
    inventory,
    limit,
    categoryId,
    deleteModal,
    categories,
  } = props;

  let categoriesList = [];

  if (categories.length > 0) {
    let allCat = {
      id: 0,
      name: "All Categories",
    };

    categoriesList.push(
      <option key={allCat.id + 32221} value={allCat.id}>
        {allCat.name}
      </option>
    );
    categories.forEach((item, index) => {
      categoriesList.push(
        <option key={index} value={item.id}>
          {item.name}
        </option>
      );
    });
  }

  return (
    <ErrorBoundary>
      <div className="ordersContent">
        {confirmModal ? (
          <div className="inventoryModal">
            <div
              className="inventoryModalBackdrop"
              onClick={closeConfirmModal}
            ></div>
            <div className="ConfrimModalPopup animated bounceIn">
              <div
                onClick={closeConfirmModal}
                className="AddItemModalConfirmX"
              >
                <ClearIcon fontSize="small" color="inherit" />
              </div>
              <span>This item will be marked as out of stock!</span>
              <div className="confirmationModalButtons">
                <div
                  className="confrimationModalButtonCancel"
                  onClick={closeConfirmModal}
                >
                  Cancel
                </div>
                <div
                  className="confrimationModalButtonContinue"
                  onClick={onContinueHandler}
                >
                  Continue
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {deleteModal ? (
          <div className="inventoryModal">
            <div
              className="inventoryModalBackdrop"
              onClick={closeDeleteModal}
            ></div>
            <div className="AddItemModalPopup animated bounceIn">
              <div
                onClick={closeDeleteModal}
                className="AddItemModalConfirmX"
              >
                <ClearIcon fontSize="small" color="inherit" />
              </div>
              <div className="modalCircle centerText">
                <DoneIcon color="inherit" fontSize="large" />
              </div>
              <span>Item successfully deleted!</span>
            </div>
          </div>
        ) : null}
        <div className="ordersTitle">
          <span>Your inventory</span>

          <div className="odersFilterBoxDate">
            <span className="filterBoxSpan">Sort by:</span>
            <select
              id="sort"
              onChange={handleSortChange}
              defaultValue="date-desc"
            >
              <option value="date-desc">Newest</option>
              <option value="date-asc">Oldest</option>
              <option value="name-asc">Name A-Z</option>
              <option value="name-desc">Name Z-A</option>
            </select>
          </div>
        </div>
        <div className="orderFiltersTableBox">
          <div className="orderFiltersBox">
            <span>Filters</span>
            <div className="filterRow">
              <div className="odersFilterBoxStatus">
                <span className="filterBoxSpan">Category:</span>
                <select
                  name="categoryId"
                  id="categoryId"
                  value={props.categoryId}
                  onChange={handleChangePerPage}
                >
                  {categoriesList}
                </select>
              </div>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : inventory.length ? (
            <Table
              head={[
                "Item name",
                "Price",
                "Discount",
                "Discounted price",
              ]}
              data={inventory}
              click={handleItemClick}
              delete={deleteHandler}
              icon
            />
          ) : (
            <div className="emptyListView">
              <div className="emptyListCircle">
                <FaClipboardList size={80} color="#dcdee3" />
              </div>
              <span>You don't have any items in your inventory yet.</span>
              <span>
                Click on the '+ Add item' button on the top right corner to
                start adding items.
              </span>
            </div>
          )}
          <div className="ordersPaginationBox">
            <div className="page">
              <ReactPaginate
                previousLabel={<Previous />}
                nextLabel={<Next />}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pageCount}
                marginPagesDisplayed={1}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                forcePage={initialPage}
              />
            </div>
            <div className="perPage">
              <select
                name="limit"
                id="limit"
                value={limit}
                onChange={handleChangePerPage}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
              </select>
              <span>
                Displaying 1-{limit} of {numberOfItems}
              </span>
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

const mapStateToProps = (state) => {
  return {
    inventory: state.inventory.inventory,
    loading: state.inventory.loading,
    numberOfItems: state.inventory.numberOfItems,
    pageCount: state.inventory.pageCount,
    limit: state.inventory.limit,
    page: state.inventory.page,
    sortBy: state.inventory.sortBy,
    sortOrder: state.inventory.sortOrder,
    categoryId: state.inventory.categoryId,
    searchInput: state.search.searchInput,
    profile: state.profile.profileDetails,
    itemLoading: state.addItem.itemLoading,
    done: state.addItem.done,
    itemDetails: state.addItem.itemDetails,
    itemFullDetails: state.addItem.itemFullDetails,
    deleteModal: state.addItem.deleteModal,
    categories: state.addItem.categories,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getInventory: (limit, page, sortBy, sortOrder, searchInput, categoryId) =>
      dispatch(
        actions.getInventory(limit, page, sortBy, sortOrder, searchInput, categoryId)
      ),
    updatePerPageSelect: (name, value) =>
      dispatch(actions.updatePerPageSelectInventory(name, value)),
    updatePageSelect: (value) =>
      dispatch(actions.updatePageSelectInventory(value)),
    updateItemDetails: (name, value) =>
      dispatch(actions.updateItemDetails(name, value)),
    PutItem: (itemObj, supplierID) =>
      dispatch(actions.PutItem(itemObj, supplierID)),
    DeleteItem: (itemID, supplierID) =>
      dispatch(actions.DeleteItem(itemID, supplierID)),
    getCategories: () => dispatch(actions.getCategories()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Inventory);
